import React, { useEffect, useState } from "react";
import TextArea from "antd/lib/input/TextArea";
import { Collapse } from "antd";
import Select from "@atlaskit/select";
import Textfield from "@atlaskit/textfield";

const CommentBox = ({ action, update }) => {
  const types = [
    { label: "-None-", value: "" },
    { label: "Project Role", value: "role" },
    { label: "Group", value: "group" },
  ];

  const [visibilityType, setVisibilityType] = useState(types[0]);
  const [visibility, setVisibility] = useState({
    type: "",
    value: "",
  });
  const [groupOrRole, setGroupOrRole] = useState("");
  const [value, setValue] = useState("");
  const { Panel } = Collapse;

  let commentTemplate = {
    body: {
      type: "doc",
      version: 1,
      content: [
        {
          type: "paragraph",
          content: [
            {
              text: "",
              type: "text",
            },
          ],
        },
      ],
    },
  };

  useEffect(() => {
    if (action && action.body && action.body !== value) {
      const bodyObject = JSON.parse(action.body);
      setValue(bodyObject.body.content[0].content[0].text);
      if (bodyObject.visibility) {
        setVisibility(bodyObject.visibility);
        setVisibilityType(types.find((t) => t.value === bodyObject.visibility.type));
        setGroupOrRole(bodyObject.visibility.value);
      }
    } else if (action && !action.body) {
      setValue("");
      setVisibility({
        type: "",
        value: "",
      });
      setVisibilityType(types[0]);
      setGroupOrRole("");
    }
  }, [action]);

  const onChangeBody = (e) => {
    commentTemplate.body.content[0].content[0].text = e.target.value;
    action.body = JSON.stringify(commentTemplate);
    update();
    setValue(e.target.value);
  };
  const changeVisibilityType = (opt) => {
    visibility.type = opt.value;
    //clear on empty
    if (opt.value === "") {
      delete commentTemplate.visibility;
    } else {
      commentTemplate["visibility"] = visibility;
    }
    action.body = JSON.stringify(commentTemplate);

    setVisibilityType(opt);
    setVisibility(visibility);
    update();
  };
  const onChange = (e) => {
    visibility.value = e.target.value;
    commentTemplate["visibility"] = visibility;
    action.body = JSON.stringify(commentTemplate);

    setVisibility(visibility);
    setGroupOrRole(e.target.value);
    update();
  };
  const expandDefault = visibilityType.value !== "" ? [1] : [];

  return (
    <>
      <TextArea onChange={onChangeBody} name="comment" value={value} resize="auto" className="ihub-comment-box" rows={10} />
      <Collapse defaultActiveKey={expandDefault} ghost>
        <Panel header="Comment Visibility" key="1">
          <Select name="visibilityType" options={types} value={visibilityType} onChange={changeVisibilityType} />
          <br></br>
          {visibilityType.value !== "" && (
            <>
              Enter {visibilityType.label}:
              <Textfield name="groupOrRole" isCompact={true} onChange={onChange} value={groupOrRole} />
            </>
          )}
        </Panel>
      </Collapse>
    </>
  );
};
export default CommentBox;
